import React from "react";

export default function AIIFACTA() {
  return (
    <section className="aiifa-cta-section text-center">
      <div className="container">
        <div className="aiifa-cta-content d-flex justify-content-between align-items-center flex-wrap">
          <h2 className="aiifa-cta-title mb-3 mb-md-0 text-white">
            AIIFA Sustainable Steel Manufacturers Association
          </h2>
          <a href="/contact" target="_blank" rel="noopener noreferrer">
            <button className="aiifa-cta-btn">GET A QUOTE</button>
          </a>

        </div>
      </div>
    </section>
  );
}
